module.exports = __webpack_public_path__ + "media/images/brand/logo-06-e1ccbcd3a06a47bfc07ff1ed8bcd7feb.png";